import React from 'react';
import { SxProps, Typography } from '@mui/material';
import { IUser } from '../../../../interfaces/user.interface';
import { IPost } from '../../../../interfaces/post.interface';

interface PostOwnerNameProps {
  userData?: IUser | IPost['user']; // Accept embedded user data from post
  variant?: 'body2' | 'subtitle1';
  sx?: SxProps;
}

const PostOwnerName = ({
  userData,
  sx,
  variant = 'body2',
}: PostOwnerNameProps) => {
  const getOwnerName = () => {
    if (!userData) {
      return '';
    }

    // Prefer company-style names whenever available, regardless of whether
    // a full IUser.role field is present. This covers:
    // - New structure: user.company.companyName
    // - Legacy structure: user.companyInfo.companyName
    // - Direct field on embedded user: user.companyName
    const companyName =
      (userData as any)?.company?.companyName ||
      (userData as any)?.companyInfo?.companyName ||
      (userData as any)?.companyName;

    if (companyName) {
      return companyName;
    }

    // Safely construct full name, handling possible undefined values
    return (
      [userData.firstName, userData.lastName].filter(Boolean).join(' ') ||
      'Unknown User'
    );
  };

  const ownerName = getOwnerName();

  if (!ownerName) {
    return null;
  }

  return (
    <Typography variant={variant} sx={sx}>
      {ownerName}
    </Typography>
  );
};

export default PostOwnerName;
